import axios from "axios";
import { SupabaseClient } from "@supabase/supabase-js";
import { supabase } from "../../config/supabaseClient";
import { extractSpotifyID, extractUsername, validateSpotifyPodcastUrl } from "./OnboardingFlow";
import { appendPlatformOnboarded } from "./UserDatabase";
import { StaticVariables } from "../StaticVariables";
import { timeSearchRpc } from "../searchRpcTiming";
import { fireProductBreadcrumbs } from "../fireProductBreadcrumbs";
// const API_BASE = "https://demo.thesearchbubble.com";
const API_BASE = "https://dev.thesearchbubble.com";

// import { Configuration, OpenAIApi } from "openai";
const slackToken = "xoxb-4117828880165-5021374947286-Srzu3WPZg8n26bq5gHCrjaGX";

export async function storeUserContent(
  provider_id: any,
  username: any,
  caption: any,
  like_count: any,
  comments_count: any,
  comments: any,
  media_url: any = "",
  permalink: any,
  thumbnail_url: any,
  post_id: any,
  post_date: any,
  type: any,
  auth_user_id: string
) {
  // TODO - for testing purposes we will allow storing the same post multiple times for different users since right now we allow having the same facebook account for multiple users.
  const { data }: any = await supabase
    .from("content_instagram")
    .select("*")
    .eq("post_id", post_id)
    .eq("user_id", auth_user_id);
  if (data && data.length === 0) {
    let storage_url = "";
    let thumbnail = "";
    if (media_url && media_url !== "") {
      const response = await fetch(media_url);

      const imageBlob = await response.blob();

      if (
        imageBlob.type === "image/jpeg" ||
        imageBlob.type === "video/mp4" ||
        imageBlob.type === "image/png" ||
        imageBlob.type === "image/webp"
      ) {
        const mediaType = imageBlob.type.split("/")[0];
        const mediaExt = imageBlob.type.split("/")[1];

        var { data: upload, error } = await supabase.storage
          .from("content")
          .upload(`${username}/${mediaType}${post_id}.${mediaExt}`, imageBlob, {
            contentType: imageBlob.type,
            cacheControl: "31536000",
          });

        var { data: imageUrl }: any = await supabase.storage
          .from("content")
          .getPublicUrl(`${username}/${mediaType}${post_id}.${mediaExt}`);

        if (imageUrl && imageUrl.publicUrl) {
          storage_url = imageUrl.publicUrl;
        }
      }
    }
    if (thumbnail_url && thumbnail_url !== "") {
      const response = await fetch(thumbnail_url);

      const imageBlob = await response.blob();

      if (
        imageBlob.type === "image/jpeg" ||
        imageBlob.type === "image/png" ||
        imageBlob.type === "image/webp"
      ) {
        const mediaType = imageBlob.type.split("/")[0];
        const mediaExt = imageBlob.type.split("/")[1];

        await supabase.storage
          .from("reel_thumbnail")
          .upload(`${username}/${mediaType}${post_id}.${mediaExt}`, imageBlob, {
            contentType: imageBlob.type,
            cacheControl: "31536000",
          });

        var { data: imageUrlThumbnail }: any = await supabase.storage
          .from("reel_thumbnail")
          .getPublicUrl(`${username}/${mediaType}${post_id}.${mediaExt}`);

        if (imageUrlThumbnail && imageUrlThumbnail.publicUrl) {
          thumbnail = imageUrlThumbnail.publicUrl;
        }
      }
    }

    let postCaption = "";
    if (caption) {
      postCaption = caption;
    }

    const { data: dataRes } = await supabase
      .from("content_instagram")
      .insert({
        provider_id,
        caption: postCaption,
        like_count,
        comments_count,
        media_url,
        storage_url,
        permalink,
        post_id,
        type,
        post_date,
        user_id: auth_user_id,
        thumbnail,
      })
      .select();

    const { data: content }: any = await supabase
      .from("content_new")
      .insert({
        user_id: auth_user_id,
        post_id,
        caption: postCaption,
        permalink,
        media_url: storage_url,
        platform: "instagram",
        post_date,
        type,
        metadata: JSON.stringify({
          like_count,
          comments_count,
          provider_id,
        }),
        raw_content_id: dataRes ? dataRes[0].id : "",
        thumbnail,
      })
      .select();

    if (comments && comments.data && comments.data.length) {
      comments.data.map(async (text: any) => {
        const { data, error }: any = await supabase.from("comments").insert([
          {
            user_id: auth_user_id,
            post_id,
            comment: text.text,
            isActive: true,
            timestamp: text.timestamp,
            comment_id: text.id,
            content_id: content ? content[0].id : "",
            platform: "instagram",
          },
        ]);
      });
    }
  }
  // if (data.length) {
  // 	await supabase.from("content").delete().eq("post_id", id);
  // }
}

export async function storeContent(username: any) {
  const { data: post } = await supabase
    .from("content_new")
    .select("*")
    .eq("username", username)
    .eq("storage_url", "");

  if (post && post.length) {
    post.map(async (media: any) => {
      const response = await fetch(media.media_url);
      const imageBlob = await response.blob();
      const mediaType = imageBlob.type.split("/")[0];
      const mediaExt = imageBlob.type.split("/")[1];
      if (
        imageBlob.type === "image/jpeg" ||
        imageBlob.type === "video/mp4" ||
        imageBlob.type === "image/png" ||
        imageBlob.type === "image/webp"
      ) {
        var { data, error } = await supabase.storage
          .from("content")
          .upload(
            `${username}/${mediaType}${media.post_id}.${mediaExt}`,
            imageBlob,
            {
              contentType: imageBlob.type,
              cacheControl: "31536000",
            }
          );

        var { data: imageUrl }: any = await supabase.storage
          .from("content")
          .getPublicUrl(`${username}/${mediaType}${media.post_id}.${mediaExt}`);

        var { data: url }: any = await supabase
          .from("content")
          .update({ storage_url: imageUrl.publicUrl })
          .eq("username", username)
          .eq("post_id", media.post_id);
      }
    });
  }
}

export function generateRandom12DigitNumber() {
  // Generate a random number between 100000000000 and 999999999999
  return (
    Math.floor(Math.random() * (9999999999999999 - 1000000000000000 + 1)) +
    1000000000000000
  );
}

function isMissingOriginalImageColumnError(error: any) {
  const message = String(
    error?.message || error?.details || error?.hint || ""
  ).toLowerCase();
  return (
    message.includes("original_image") ||
    message.includes("schema cache") ||
    message.includes("could not find")
  );
}

export async function storeContentNew(
  post_id: any,
  user_id: any,
  name: string,
  productImage: string,
  type: string,
  date: any,
  platform: any,
  link: string,
  username: string,
  originalImage?: string | null
) {
  // let randomNumber = generateRandom12DigitNumber();

  const contentRow: Record<string, unknown> = {
    post_id: post_id,
    product_name: name || "",
    user_id: user_id,
    content_title: name || " ",
    media_url: productImage,
    type,
    platform,
    post_date: date || new Date(),
    raw_content_id: null,
    metadata: "",
    combined_text: name || "",
    permalink: "",
    external_link: link,
    thumbnail: "",
    caption: "",
  };
  if (originalImage) {
    contentRow.original_image = originalImage;
  }

  let { data: content, error: contentError }: any = await supabase
    .from("content_new")
    .insert([contentRow]);

  // content_new may not have original_image yet — retry without it so add still works
  if (contentError && originalImage && isMissingOriginalImageColumnError(contentError)) {
    delete contentRow.original_image;
    ({ data: content, error: contentError } = await supabase
      .from("content_new")
      .insert([contentRow]));
  }

  if (contentError) {
    console.error("storeContentNew content_new insert error:", contentError);
  }

  if (content && content.length > 0) {
    return content;
  }

  const { data, error: idError } = await supabase
    .from(username)
    .select("id")
    .order("id", { ascending: false })
    .limit(1);

  if (idError) {
    console.error("storeContentNew id lookup error:", idError);
  }

  const lastId = data?.[0]?.id || 0;
  const nextId = lastId + 1;

  // Per-user feed tables do not have original_image — mirror Product Bank insert shape
  const { data: contentNewData, error: userInsertError }: any = await supabase
    .from(`${username}`)
    .insert({
      index: "active",
      id: nextId,
      post_id: post_id,
      product_name: name || "",
      user_id: user_id,
      content_title: name || " ",
      media_url: productImage,
      type,
      platform,
      post_date: date || new Date(),
      raw_content_id: null,
      metadata: "",
      combined_text: name || "",
      permalink: "",
      external_link: link,
      thumbnail: "",
      caption: "",
    });

  if (userInsertError) {
    throw userInsertError;
  }

  if (String(type || "").toUpperCase() === "PRODUCT" && post_id) {
    fireProductBreadcrumbs(username, {
      oncePerBrowser: false,
      postIds: [String(post_id)],
    });
  }

  if (contentNewData && contentNewData.length > 0) {
    return contentNewData;
  }
  return null;
}

export async function storeOtherContent(username: any) {
  const { data: post } = await supabase
    .from("content")
    .select("*")
    .eq("username", username)
    .eq("storage_url", "");

  if (post && post.length) {
    post.map(async (media: any) => {
      const response = await fetch(media.media_url);
      const imageBlob = await response.blob();
      const mediaType = imageBlob.type.split("/")[0];
      const mediaExt = imageBlob.type.split("/")[1];

      var { data, error } = await supabase.storage
        .from("content_new")
        .upload(
          `${username}/${mediaType}${media.post_id}.${mediaExt}`,
          imageBlob,
          {
            contentType: imageBlob.type,
            cacheControl: "31536000",
          }
        );

      var { data: imageUrl }: any = await supabase.storage
        .from("content")
        .getPublicUrl(`${username}/${mediaType}${media.post_id}.${mediaExt}`);

      var { data: url }: any = await supabase
        .from("content")
        .update({ storage_url: imageUrl.publicUrl })
        .eq("username", username)
        .eq("post_id", media.post_id);
    });
  }
}

//-- change dependency
// export async function getFeedLength(
//   user_id: any,
//   query: any = "",
//   filter: any = [],
//   username:any
// ) {
//   let { count }: any = await supabase
//     // .from(`${username}`)
//     .from("content_new")
//     .select("*", { count: "exact", head: true })
//     .in("user_id", user_id)
//     .in("type", filter)
//     // .or(
//     //   `or(caption.ilike.%${query}%,tagg.ilike.%${query}%)`
//     // )
//     .or(
//       `or(caption.ilike.%${query}%,tagg.ilike.%${query}%,metadata.ilike.%${query}%,ocr.ilike.%${query}%)`
//     )
//     .ilike("index", "%active%");
//   return count;
// }
//-- change dependency

export async function getAdLength(
  user_id: string,
  query: any = "",
  filter: any[],
  username: any,
  client: SupabaseClient = supabase
) {
  return timeSearchRpc("db:ads_content count (getAdLength)", async () => {
    let { count: adCount }: any = await client
      .from("ads_content")
      .select("*", { count: "exact", head: true })
      .ilike("index", "%ad%")
      .eq("user_id", user_id);
    return adCount;
  });
}

export async function updateRefClick(
  post_id: any,
  user_id: any,
  client: SupabaseClient = supabase
) {
  await client.rpc("updateref", { i: `${post_id}`, userid: `${user_id}` });
}

export async function getPostClicks(
  username: any,
  max: any,
  startDate: any,
  endDate: any,
  user_id: any
) {
  const { data } = await supabase.rpc("get_posts_date_rangee", {
    route_name: `/${username}`,
    start_date: startDate,
    end_date: endDate,
    max_res: max,
    userid: user_id,
  });
  const resultArray = await Promise.all(
    data
      .filter((item: any) => {
        // Validate that `details` is a JSON string with the required structure
        try {
          const parsedDetails = JSON.parse(item.details);
          return (
            parsedDetails.post_id &&
            parsedDetails.media_url &&
            parsedDetails.platform
          );
        } catch (e) {
          return false; // Skip invalid JSON or missing properties
        }
      })
      .map(async (item: any) => {
        const parsedDetails = JSON.parse(item.details);
        const { data: postData } = await supabase
          .from(`${username}`)
          .select("*")
          .ilike("media_url", `%${parsedDetails.post_id}%`);

        const { data: productData } = await supabase
          .from(username)
          .select("*")
          .eq("post_id", parsedDetails.post_id)
          .eq("user_id", user_id);

        return {
          post_id: parsedDetails.post_id,
          count: item.count,
          additionalData: postData?.[0] || productData?.[0] || null,
        };
      })
  );

  if (data.length) {
    return resultArray;
  }

  return [];
}

// export async function getShoppableClicks(
//   username: any,
//   max: any,
//   startDate: any,
//   endDate: any,
//   user_id: any
// ) {
//   const { data } = await supabase.rpc("get_shoppable_date_rangee", {
//     route_name: `/${username}`,
//     start_date: startDate,
//     end_date: endDate,
//     max_res: max,
//     userid: user_id,
//   });
//   const resultArray = await Promise.all(
//     data.map(async (item: any) => {
//       const parsedDetails = JSON.parse(item.details);
//       const { data: postIdData } = await supabase
//         .from(`${username}`)
//         .select("*")
//         .eq("post_id", parsedDetails.post_id);
//       const { data: postData } = await supabase
//         .from(`${username}`)
//         .select("*")
//         .ilike("media_url", `%${parsedDetails.post_id}%`);
//       const { data: productData } = await supabase
//         .from("product_bank")
//         .select("*")
//         .eq("product_id", `${parsedDetails.post_id}`)
//         .eq("user_id", user_id);

//       return {
//         post_id: parsedDetails.post_id,
//         count: item.count,
//         additionalData: postIdData?.[0] || postData?.[0] || productData?.[0] || null,
//       };
//     })
//   );
//   if (data.length) {
//     return resultArray;
//   }

//   return [];
// }



export async function getShoppableClicks(
  username: any,
  max: any,
  startDate: any,
  endDate: any,
  user_id: any
) {
  const { data, error } = await supabase.rpc("get_shoppable_date_rangee", {
    route_name: `/${username}`,
    start_date: startDate,
    end_date: endDate,
    max_res: max,
    userid: user_id,
  });
  if (error) throw error;
  if (!Array.isArray(data) || data.length === 0) return [];

  // Parse once
  const parsed = data
    .map((item: any) => {
      try {
        const details = typeof item.details === "string" ? JSON.parse(item.details) : item.details;
        const post_id = details?.post_id;
        if (post_id == null) return null;
        return { post_id: String(post_id), count: item.count };
      } catch {
        return null;
      }
    })
    .filter(Boolean) as { post_id: string; count: number }[];

  if (!parsed.length) return [];

  const postIds = Array.from(new Set(parsed.map((p) => p.post_id)));

  // ✅ Only fetch what you need for popularity ordering
  // (If later you truly need more fields, add them explicitly)
  const POST_COLS = "post_id, media_url, shop_link,thumbnail";
  const PRODUCT_COLS = "product_id, url";

  // Batch fetch post_id matches
  const [{ data: postIdRows, error: postErr }, { data: productRows, error: prodErr }] =
    await Promise.all([
      supabase.from(username).select(POST_COLS).in("post_id", postIds),
      supabase
        .from("product_bank")
        .select(PRODUCT_COLS)
        .in("product_id", postIds)
        .eq("user_id", user_id),
    ]);

  if (postErr) throw postErr;
  if (prodErr) throw prodErr;

  const postIdMap = new Map<string, any>();
  (postIdRows || []).forEach((row: any) => {
    const id = row?.post_id != null ? String(row.post_id) : "";
    if (id && !postIdMap.has(id)) postIdMap.set(id, row);
  });

  const productMap = new Map<string, any>();
  (productRows || []).forEach((row: any) => {
    const id = row?.product_id != null ? String(row.product_id) : "";
    if (id && !productMap.has(id)) productMap.set(id, row);
  });

  // Media fallback ONLY for ids still unresolved AND only if needed
  // NOTE: this preserves functionality, but avoids the expensive scan when post_id exists.
  const unresolved = postIds.filter((id) => !postIdMap.has(id));
  const mediaMap = new Map<string, any>();

  // If unresolved is small, do exact per-id query with limit(1) (keeps semantics).
  // If unresolved is large, batching OR/ILIKE tends to be slower; this avoids killing performance.
  if (unresolved.length > 0) {
    const hardCap = 25; // protects you from scanning tons of rows; tune if needed

    const idsToCheck = unresolved.slice(0, hardCap);
    await Promise.all(
      idsToCheck.map(async (id) => {
        const { data: mediaRows } = await supabase
          .from(username)
          .select(POST_COLS)
          .ilike("media_url", `%${id}%`)
          .limit(1);

        if (mediaRows?.[0]) mediaMap.set(id, mediaRows[0]);
      })
    );
  }

  return parsed.map((p) => ({
    post_id: p.post_id,
    count: p.count,
    additionalData:
      postIdMap.get(p.post_id) ||
      mediaMap.get(p.post_id) ||
      productMap.get(p.post_id) ||
      null,
  }));
}


export async function changeAdSequence(
  post_id: any,
  index: any,
  username: any,
  user_id: any
) {
  await supabase
    .from(`${username}`)
    .update({ ads_order: index })
    .eq("post_id", post_id)
    .eq("user_id", user_id);
  await supabase
    .from("ads_content")
    .update({ ads_order: index })
    .eq("post_id", post_id)
    .eq("user_id", user_id);
}
export async function removePostasAd(
  post_id: any,
  username: any,
  user_id: any
) {
  await supabase
    .from(`${username}`)
    .update({ index: "active", ads_order: null })
    .eq("post_id", post_id)
    .eq("user_id", user_id);

  const { data: adPost, error } = await supabase
    .from("ads_content")
    .select("*")
    .eq("post_id", post_id)
    .eq("user_id", user_id)

    .eq("username", username);
  if (adPost && adPost.length) {
    const { error: adDeleteError } = await supabase
      .from("ads_content")
      .delete()
      .eq("post_id", post_id)
      .eq("user_id", user_id);
    if (adDeleteError) {
    }
  }
}
export async function removePostasFeature(
  post_id: any,
  username: any,
  user_id: any
) {
  await supabase
    .from(`${username}`)
    .update({ index: "active" })
    .eq("post_id", post_id)
    .eq("user_id", user_id);
}

export async function deletePostFunction(
  post_id: any,
  username: any,
  user_id: any
) {
  const { error } = await supabase
    .from(`${username}`)
    .delete()
    .eq("post_id", post_id);
  const { error: contentNewError } = await supabase
    .from("content_new")
    .delete()
    .eq("post_id", post_id)
    .eq("user_id", user_id);
  await supabase
    .from("content_instagram")
    .delete()
    .eq("post_id", post_id)
    .eq("user_id", user_id);

  await supabase
    .from("content_comments")
    .delete()
    .eq("post_id", post_id)
    .eq("user_id", user_id);
  await supabase
    .from("content_linkedin")
    .delete()
    .eq("post_id", post_id)
    .eq("user_id", user_id);
  await supabase
    .from("content_newsletter")
    .delete()
    .eq("post_id", post_id)
    .eq("user_id", user_id);
  await supabase
    .from("content_pinterest")
    .delete()
    .eq("post_id", post_id)
    .eq("user_id", user_id);
  await supabase
    .from("content_podcast")
    .delete()
    .eq("post_id", post_id)
    .eq("user_id", user_id);
  await supabase
    .from("content_product")
    .delete()
    .eq("post_id", post_id)
    .eq("user_id", user_id);
  await supabase
    .from("content_tiktok")
    .delete()
    .eq("post_id", post_id)
    .eq("user_id", user_id);
  await supabase
    .from("content_twitter")
    .delete()
    .eq("tweet_id", post_id)
    .eq("user_id", user_id);
  await supabase
    .from("content_yt")
    .delete()
    .eq("video_id", post_id)
    .eq("user_id", user_id);

  const { error: productError } = await supabase
    .from("product_bank")
    .delete()
    .eq("product_id", post_id)
    .eq("user_id", user_id);
  await supabase
    .from("broken_links_table")
    .delete()
    .eq("post_id", post_id)
    .eq("user_id", user_id);
  await supabase
    .from("ads_content")
    .delete()
    .eq("post_id", post_id)
    .eq("user_id", user_id);
  await supabase
    .from("analytics")
    .delete()
    .eq("user_id", user_id)
    .ilike("details", `%${post_id}%`);
}
export async function getAdsFeedLength(user_id: any, username: any) {
  let { data: count }: any = await supabase
    .from("ads_content")
    .select("*")
    .eq("user_id", user_id)
    .eq("index", "active,ad");
  const uniquePosts = Object.values(
    (count || []).reduce((acc: any, post: any) => {
      acc[post.post_id] = post;
      return acc;
    }, {})
  );

  return uniquePosts.length;
}

//---------------change dependency

export async function reduceAdSequence(user_id: any, username: any) {
  let { data } = await supabase
    .from(`${username}`)
    .select("*")
    .eq("user_id", user_id)
    .eq("index", "active,ad");
  if (data && data.length) {
    data.map(async (ad: any) => {
      if (ad.ads_order === 0) {
        await supabase
          .from(`${username}`)
          .update({ ads_order: null })
          .eq("post_id", ad.post_id)
          .eq("user_id", user_id);
      } else {
        await supabase
          .from(`${username}`)
          .update({ ads_order: `${ad.ads_order - 1}` })
          .eq("post_id", ad.post_id)
          .eq("user_id", user_id);
      }
    });
  }
  let { data: ads } = await supabase
    .from("ads_content")
    .select("*")
    .eq("user_id", user_id)
    .eq("index", "active,ad");
  if (ads && ads.length) {
    ads.map(async (ad: any) => {
      if (ad.ads_order === 0) {
        await supabase
          .from("ads_content")
          .update({ ads_order: null })
          .eq("post_id", ad.post_id)
          .eq("user_id", user_id);
      } else {
        await supabase
          .from("ads_content")
          .update({ ads_order: `${ad.ads_order - 1}` })
          .eq("post_id", ad.post_id)
          .eq("user_id", user_id);
      }
    });
  }
}

//---------------change dependency
export async function orderAdSequence(
  user_id: any,
  sourceIndex: any,
  targetIndex: any,
  post_id: any,
  username: any
) {
  let { data: sourceAd }: any = await supabase
    .from(`${username}`)
    .update({ ads_order: sourceIndex })
    .eq("user_id", user_id)
    .eq("ads_order", `${targetIndex}`)
    .select();

  let { data: targetAd }: any = await supabase
    .from(`${username}`)
    .update({ ads_order: targetIndex })
    .eq("user_id", user_id)
    .eq("post_id", `${post_id}`)
    .select();

  let { data: sourceAdContent, error: s }: any = await supabase
    .from("ads_content")
    .update({ ads_order: sourceIndex })
    .eq("user_id", user_id)
    .eq("ads_order", `${targetIndex}`)
    .select();

  let { data: targetAdContent, error: t }: any = await supabase
    .from("ads_content")
    .update({ ads_order: targetIndex })
    .eq("user_id", user_id)
    .eq("post_id", `${post_id}`)
    .select();
}

export async function getGLobalHashtags(includedUsers: any[], max: any) {
  let { data } = await supabase
    .from("searches")
    .select("*")
    .eq("type", `hashtag`)
    .in("username", includedUsers)
    .order("query")
    .order("occurrences", { ascending: false })
    .range(0, max - 1);

  if (data) {
    return data;
  }
}

//--- for global ------------
export async function getGlobalActiveFilters(includedUserIds: any[]) {
  const { data, error }: any = await supabase
    .from("content_new")
    .select("type")
    .in("user_id", includedUserIds);

  const uniqueSet = new Set<number>();
  data.filter((obj: any) => {
    if (!uniqueSet.has(obj.media_product_type)) {
      uniqueSet.add(obj.media_product_type);
    }
  });

  return uniqueSet;
}

type ResYtStoreContent = {
  error: boolean;
  message: string;
};

export async function storeYoutubeChannel(
  user_id: string,
  channel_id: string,
  username: any
): Promise<ResYtStoreContent> {
  const res = {
    error: false,
    message: "",
  };

  try {
    if (!channel_id) return res;

    const { username: extractedYoutubeUsername, error: extractError } =
      extractUsername(channel_id, "youtube");
    if (extractError) {
      throw new Error(extractError);
    }

    const newPlatformsUsername = extractedYoutubeUsername;

    try {
      const api_url = `${StaticVariables().API_BASE}/verify-youtube`;
      const validationResponse = await axios.post(api_url, {
        username: newPlatformsUsername,
      });

      if (validationResponse?.data?.success !== true) {
        throw new Error("Invalid YouTube channel");
      }

      // ✅ At this point, verify-youtube returned TRUE.
      // Start the rest of the work in the background and return immediately.

      (async () => {
        try {
          // 1. Update Supabase
          await supabase
            .from("user")
            .update({
              // If you want to store uploadPlaylistId instead, switch this back.
              youtube_playlist_id:
                validationResponse?.data?.channelInfo?.youtubeChannelUrl,
              youtube_channel_id:
                validationResponse?.data?.channelInfo?.channelId,
              youtube_username: newPlatformsUsername,
              is_youtube_on: true,
            })
            .eq("username", username);

          // 2. Fetch regular videos
          const url = `${API_BASE}/fetch/youtube`;

          await axios.post(
            url,
            {
              userId: user_id,
              channelId: validationResponse?.data?.channelInfo?.id,
              username: username,
            },
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          );

          // // 3. Fetch shorts
          // const urlYtShorts = `${API_BASE}/api/youtube/shorts`;

          // await axios.post(
          //   urlYtShorts,
          //   {
          //     userId: user_id,
          //     channelId: validationResponse?.data?.channelInfo?.id,
          //     username: username,
          //   },
          //   {
          //     headers: {
          //       "Content-Type": "application/json",
          //     },
          //   }
          // );

          // 4. Slack notification
          await sendNewIntegrationSlackUpdate(username, user_id, "YouTube");
        } catch (err) {
          // Background error — log it, but don't affect the user flow.
          console.error("YouTube integration background error", err);
        }
      })();

      // ⬅️ Important: we return here, immediately after verification success.
      void appendPlatformOnboarded({ userId: user_id, username }, "youtube");
      return res;
    } catch (error: any) {
      throw new Error(
        error?.response?.data?.message || "YouTube validation failed"
      );
    }
  } catch (error: any) {
    res.error = true;
    if (
      error &&
      error?.response &&
      error.response?.data &&
      error.response.data?.message
    ) {
      res.message = error.response.data.message;
    } else {
      res.message =
        error?.message ||
        "Server error: please try again later or contact our support team.";
    }
    return res;
  }
}

type ResNewsletterStoreContent = {
  error: boolean;
  message: string;
};
export async function storeNewsletterChannel(
  user_id: string,
  email: string,
  username: any,
  websiteLink?: string
): Promise<ResNewsletterStoreContent> {
  const res = {
    error: false,
    message: "",
  };
  try {
    const url = `${API_BASE}/api/user/store/newsletter`;

    const resServer = axios.post(
      url,
      { userId: user_id, user: username, email: email },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    const { data: update, error } = await supabase
      .from("user")
      .update({ show_newsletter: true, is_newsletter_on: true })
      .eq("user_id", user_id);
    // const { success, message } = resServer.data;

   sendNewIntegrationSlackUpdate(username, user_id, "Newsletter");
   void appendPlatformOnboarded({ userId: user_id, username }, "newsletter");

    // if (!success) {
    //   res.error = true;
    //   res.message = message;
    //   return res;
    // }

    return res;
  } catch (error: any) {
    res.error = true;
    if (
      error &&
      error?.response &&
      error.response?.data &&
      error.response.data?.message
    ) {
      res.message = error.response.data.message;
    } else {
      res.message =
        "Server error: please try again later or contact our support team.";
    }
    return res;
  }
}

export type LinkedInProfileType = "personal" | "company";

export interface ParsedLinkedInProfile {
  slug: string;
  profileType: LinkedInProfileType;
  url: string;
  storageKey: string;
}

const LINKEDIN_PROFILE_REGEX =
  /(?:https?:\/\/)?(?:www\.)?linkedin\.com\/(in|pub|profile|showcase|company)\/([^/?#]+)/i;

export function parseLinkedInProfile(
  input: string
): ParsedLinkedInProfile | null {
  const trimmed = input?.trim() || "";
  if (!trimmed) return null;

  if (/^company\//i.test(trimmed)) {
    const slug = trimmed.replace(/^company\//i, "").replace(/^@/, "");
    if (!slug) return null;
    return {
      slug,
      profileType: "company",
      url: `https://www.linkedin.com/company/${slug}`,
      storageKey: `company/${slug}`,
    };
  }

  if (/linkedin\.com/i.test(trimmed)) {
    const cleanUrl = trimmed.split(/[?#]/)[0];
    const match = cleanUrl.match(LINKEDIN_PROFILE_REGEX);
    if (!match?.[2]) return null;

    const pathType = match[1].toLowerCase();
    const slug = match[2].split("/")[0];
    const isCompany = pathType === "company";

    return {
      slug,
      profileType: isCompany ? "company" : "personal",
      url: isCompany
        ? `https://www.linkedin.com/company/${slug}`
        : `https://www.linkedin.com/in/${slug}`,
      storageKey: isCompany ? `company/${slug}` : slug,
    };
  }

  const slug = trimmed.replace(/^@/, "");
  if (!slug) return null;

  return {
    slug,
    profileType: "personal",
    url: `https://www.linkedin.com/in/${slug}`,
    storageKey: slug,
  };
}

export function extractLinkedInUsername(url: string): string {
  try {
    const parsed = parseLinkedInProfile(url);
    if (!parsed) {
      throw new Error("Invalid LinkedIn URL");
    }
    return parsed.storageKey;
  } catch (error: any) {
    console.error(error.message);
    return "";
  }
}

export function getLinkedInProfileName(value: string): string {
  const trimmed = value?.trim() || "";
  if (!trimmed) return "";

  const parsed = parseLinkedInProfile(trimmed);
  if (parsed) return parsed.slug;

  return trimmed.replace(/^company\//i, "").replace(/^@/, "");
}

export function normalizeLinkedInProfileUrl(input: string): string {
  const parsed = parseLinkedInProfile(input);
  return parsed?.url || "";
}

export async function storeLinkedInChannel(
  user_id: string,
  profileUrl: string,
  username: any
): Promise<ResNewsletterStoreContent> {
  const res = {
    error: false,
    message: "",
  };
  try {
    const linkedInProfileUrl = normalizeLinkedInProfileUrl(profileUrl);
    const linkedInUsername = extractLinkedInUsername(linkedInProfileUrl);

    if (!linkedInUsername) {
      throw new Error("Invalid LinkedIn profile URL");
    }

    const verifyUrl = `${StaticVariables().API_BASE}/verify-linkedin`;
    const validationResponse = await axios.post(verifyUrl, {
      username: linkedInProfileUrl,
    });

    if (validationResponse?.data?.success !== true) {
      throw new Error("Invalid LinkedIn profile URL");
    }

    const url = `${API_BASE}/fetch/linkedin`;

    const resServer: any = await axios.post(
      url,
      { userId: user_id, user: username, linkedInUsername: linkedInUsername },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    await supabase
      .from("user")
      .update({ linkedin_user: linkedInUsername, is_linkedin_on: true })
      .eq("user_id", user_id)
      .eq("username", username);


   sendNewIntegrationSlackUpdate(username, user_id, "LinkedIn");
   void appendPlatformOnboarded({ userId: user_id, username }, "linkedin");

    return res;
  } catch (error: any) {
    res.error = true;
    // Handle specific error cases
    if (error.response) {
      // Server responded with error status
      if (error.response.status === 400) {
        res.message =
          error.response.data.message ||
          "Invalid LinkedIn profile. Please check the profile URL and try again.";
      } else if (error.response.status === 500) {
        res.message =
          "Server error. Please try again later or contact support.";
      } else {
        res.message =
          error.response.data.message ||
          "An error occurred while connecting to LinkedIn.";
      }
    } else if (error.request) {
      // Request made but no response received
      res.message =
        "Unable to connect to the server. Please check your internet connection and try again.";
    } else {
      res.message = error?.message || "An unexpected error occurred. Please try again.";
    }
    return res;
  }
}

export function removeQualifiers(query: any) {
  // Parse the sentence using compromise

  const words = query.split(" ");
  const trimmedWords = words.map((word: any) => word.trim());
  return trimmedWords;
}
function createArray(query: any) {
  const words = query.split(",");
  const trimmedWords = words.map((word: any) => word.trim());
  return trimmedWords;
}
function createKeywordPermutations(keywords: any[]) {
  const combinations = [];

  for (let i = 0; i < keywords.length - 1; i++) {
    for (let j = i + 1; j < keywords.length; j++) {
      combinations.push([keywords[i], keywords[j]]);
    }
  }

  return combinations;
}


/** Dedupe concurrent + repeated embedding calls (search triggers 3 hooks that share the same query). */
const embeddingResultCache = new Map<string, unknown>();
const embeddingInflight = new Map<string, Promise<unknown>>();
const MAX_EMBEDDING_CACHE_ENTRIES = 64;

export async function getEmbedding(query: any) {
  const key = String(query);
  if (embeddingResultCache.has(key)) {
    return embeddingResultCache.get(key);
  }
  const existing = embeddingInflight.get(key);
  if (existing) {
    return existing;
  }

  const promise = (async () => {
    try {
      const response = await fetch(
        `${StaticVariables().API_BASE}/api/generate-embedding`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            query: query,
          }),
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const embedding = await response.json();

      if (embeddingResultCache.size >= MAX_EMBEDDING_CACHE_ENTRIES) {
        const oldest = embeddingResultCache.keys().next().value;
        if (oldest !== undefined) {
          embeddingResultCache.delete(oldest);
        }
      }
      embeddingResultCache.set(key, embedding);
      return embedding;
    } catch (error) {
      console.error("Error generating embedding:", error);
      return null;
    } finally {
      embeddingInflight.delete(key);
    }
  })();

  embeddingInflight.set(key, promise);
  return promise;
}
export async function getQuerySuggestions(
  query: string = "",
  openAiSearch: boolean,
  extraIds?: any[],
  category?: any,
  activeHightlights?: any
) {
  let queryKeywords: any;
  let keyword1: any;
  let keyword2: any = "";

  let keyword3: any = "";

  let commaKeyword: any;
  let similarSearchArr: any;
  let combinedWords: any;
  let combinedQuery: any;

  query = query && query.trim();
  let basicQuery;
  let searchQuery;
  let searchQuery2;
  let similarSearchQuery;
  let individualKeywordQuery;
  let individualKeywords;

  if (!query) {
    basicQuery = `tagg.ilike.%${query}%,caption.ilike.%${query}%,text.ilike.%${query}%`;
  } else if (category) {
    if (category === "searchbar") {
      let resApi;
      if (!openAiSearch) {
        queryKeywords = removeQualifiers(query);
      } else {
        if (query) {
          try {
            const { data: resApimsg } = await axios.get(
              // ${
              //   process.env.ENV === "production"
              //     ? process.env.REACT_APP_API_URL_PRODUCTION
              //     : process.env.REACT_APP_API_URL_DEV
              // }
              // `https://dev.thesearchbubble.com/api/openai/${query}`
              `https://dev.thesearchbubble.com/api/openai/${query}`
              // `https://dev.thesearchbubble.com/api/openai/${query}`
            );
            resApi = resApimsg;
          } catch (e) {
            return 0;
          }
          if (resApi && resApi.success) {
            // queryKeywords = createArray(resApi.keywords.trim());
            similarSearchArr = resApi.suggestion;
            keyword1 = resApi.keyword1 && resApi.keyword1.trim();
            keyword2 = resApi.keyword2 && resApi.keyword2.trim();
            // keyword3 = queryKeywords[1].trim();

            keyword3 = resApi.keyword3 && resApi.keyword3.trim();
          }
        }
      }
      let individualKeywords = [keyword1, keyword2, keyword3];

      individualKeywords = [...new Set(individualKeywords)];

      individualKeywordQuery =
        individualKeywords &&
        individualKeywords.map((term: any) => `text.ilike.%${term}%`).join(",");

      searchQuery = `text.ilike.%${keyword1}%`;

      const similarSearchQuery = (similarSearchArr || [])
        .map(
          (phrase: any) =>
            `and(${phrase
              .split(" ")
              .map((term: any) => `text.ilike.%${term}%`)
              .join(",")})`
        )
        .join(",");

      if (searchQuery) {
        basicQuery = `${searchQuery}`;
        if (searchQuery2) {
          basicQuery += `,${searchQuery2}`;
          if (similarSearchQuery) {
            basicQuery += `,${similarSearchQuery}`;
          }
        } else if (similarSearchQuery) {
          basicQuery += `,${similarSearchQuery}`;
        }
        if (individualKeywordQuery) {
          basicQuery += `,${individualKeywordQuery}`;
        }
      }
    } else if (
      category === "Top Hashtags" ||
      category === "Popular Searches" ||
      category === "Content Type"
    ) {
      basicQuery = `tagg.ilike.%${query}%,caption.ilike.%${query}%,text.ilike.%${query}%`;
    } else if (category === "Highlights") {
      basicQuery = `tagg.ilike.%${query}%`;
    } else {
      basicQuery = `tagg.ilike.%${query}%`;
    }
  } else {
    basicQuery = `tagg.ilike.%${query}%,caption.ilike.%${query}%,text.ilike.%${query}%`;
  }

  return {
    query: basicQuery,
    second: searchQuery,
    third: searchQuery2,
    fourth: individualKeywordQuery,
    keyword1: keyword1,
    keyword2: keyword2,
    keyword3: keyword3,
  };
}

export async function validateSpotifyShow(spotifyId: string): Promise<{
  valid: boolean;
  name?: string;
  reason?: string;
}> {
  try {
    const showUrl = `https://open.spotify.com/show/${spotifyId}`;
    const response = await axios.get("https://open.spotify.com/oembed", {
      params: { url: showUrl },
    });

    if (response.status === 200) {
      return {
        valid: true,
        name: response.data.title,
      };
    } else {
      return {
        valid: false,
        reason: response.data?.message || "Podcast not found on Spotify.",
      };
    }
  } catch (error: any) {
    const status = error?.response?.status;
    if (status === 404) {
      return { valid: false, reason: "Podcast not found on Spotify." };
    }
    return {
      valid: false,
      reason: "Could not verify this podcast on Spotify.",
    };
  }
}

export async function storePodcastChannel(
  user_id: string,
  podcastShowName: string,
  podcastShowUrl: string,
  username: string
): Promise<ResNewsletterStoreContent> {
  const res = {
    error: false,
    message: "",
  };

  try {
    const result = validateSpotifyPodcastUrl(podcastShowUrl);

    if (result.error) {
      res.error = true;
      res.message = result.message ? result.message : "Invalid Spotify Podcast link";
      return res;
    }
    const spotifyId = result.spotifyId;

    const showValidation = await validateSpotifyShow(spotifyId!);
    if (!showValidation.valid) {
      res.error = true;
      res.message = showValidation.reason ?? "Could not verify this podcast on Spotify.";
      return res;
    }

    const { error: supabaseError } = await supabase
      .from("user")
      .update({
        podcast_link: podcastShowUrl,
        podcast_showname: podcastShowName,
        podcast_artist: podcastShowName,
        podcast_id: spotifyId,
      })
      .eq("username", username);

    if (supabaseError) {
      res.error = true;
      res.message = "Failed to save podcast details. Please try again.";
      return res;
    }

    sendNewIntegrationSlackUpdate(username, user_id, "Podcast");
    void appendPlatformOnboarded({ userId: user_id, username }, "podcast");

    // Kick off the background scraping job — this can take many minutes.
    // We do NOT await it; the connection is already saved to Supabase above.
    const podcastUrl = `${API_BASE}/fetch/podcast`;
    axios
      .post(
        podcastUrl,
        {
          user: username,
          user_id: user_id,
          id: spotifyId,
          showName: podcastShowName,
          showUrl: podcastShowUrl,
        },
        { headers: { "Content-Type": "application/json" } }
      )
      .catch(() => {
        // Intentionally swallowed — the fetch job runs in the background.
      });

    // Return success immediately after the Supabase save.
    return res;
  } catch (error: any) {
    res.error = true;
    res.message = "An unexpected error occurred. Please try again.";
    return res;
  }
}
export async function fetchAllPodcastEpisodes(
  username: any,
  user_id: any,
  showLink: any,
  showId: any,
  showName: any
) {
  const url = `${API_BASE}/fetch/podcast`;

  let res: any = await axios.post(
    url,
    { user: username, user_id: user_id, id: showId, showName: showName },
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );

  if (res.data === "done") {
    return true;
  } else {
    return false;
  }
}

export async function storeTiktokUser(
  user_id: string,
  name: string,
  username: any
): Promise<ResNewsletterStoreContent> {
  const res = {
    error: false,
    message: "",
  };
  try {
    const { username: result, error: extractError } = extractUsername(name, "tiktok");
    if (extractError) {
      throw new Error(extractError);
    }

    const validationResponse = await axios.post(
      `${StaticVariables().API_BASE}/verify-tiktok`,
      { username: result }
    );

    if (validationResponse?.data?.success !== true) {
      throw new Error(validationResponse?.data?.error || "Invalid TikTok username");
    }

    await supabase
      .from("user")
      .update({ tiktok_user: result, is_tiktok_on: true })
      .eq("user_id", user_id);

    const url = `${API_BASE}/integrate/tiktok`;
    await axios.post(
      url,
      { id: user_id, tiktokUsername: name, username: username },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    // const { success, message } = resServer.data;

    sendNewIntegrationSlackUpdate(username, user_id, "TikTok");
    void appendPlatformOnboarded({ userId: user_id, username }, "tiktok");
    return res;
  } catch (error: any) {
    res.error = true;
    if (error.response) {
      // Server responded with error status
      if (error.response.status === 400) {
        res.message =
          error.response.data.message ||
          "Invalid TikTok profile. Please check the username and try again.";
      } else if (error.response.status === 500) {
        res.message =
          "Server error. Please try again later or contact support.";
      } else {
        res.message =
          error.response.data.message ||
          "An error occurred while connecting to TikTok.";
      }
    } else if (error.request) {
      // Request made but no response received
      res.message =
        "Unable to connect to the server. Please check your internet connection and try again.";
    } else {
      res.message = error?.message || "An unexpected error occurred. Please try again.";
    }
    return res;
  }
}

export async function storeInstagramUser(
  user_id: string,
  name: string,
  username: any
): Promise<ResNewsletterStoreContent> {
  const res = {
    error: false,
    message: "",
  };

  try {
    const instagramUsername = String(name || "").trim().replace(/^@/, "");
    if (!instagramUsername) {
      throw new Error("Enter a valid Instagram username");
    }

    const validationResponse = await axios.post(
      `${StaticVariables().API_BASE}/validate-instagram`,
      { username: instagramUsername }
    );

    if (validationResponse?.data?.success !== true) {
      throw new Error("Invalid Instagram username");
    }

    await supabase
      .from("user")
      .update({ instagram_username: instagramUsername, is_instagram_on: true })
      .eq("user_id", user_id);

    sendNewIntegrationSlackUpdate(username, user_id, "Instagram");
    void appendPlatformOnboarded({ userId: user_id, username }, "instagram");
    return res;
  } catch (error: any) {
    res.error = true;
    res.message =
      error?.response?.data?.message ||
      error?.message ||
      "Instagram validation failed";
    return res;
  }
}

export async function getExtraNecIds(
  queryTerm: any,
  username: any
): Promise<any[]> {
  const url = "https://nec.thesearchbubble.com:3136/api/";

  const myHeaders = new Headers({
    "Content-Type": "application/json",
    "Accept-Charset": "UTF-8",
  });

  const raw = JSON.stringify({
    text: queryTerm,
    creator: username,
  });

  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), 3000);

  const requestOptions: RequestInit = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
    signal: controller.signal,
  };

  try {
    const response = await fetch(url, requestOptions);
    const result = await response.json();
    // const dataArray = result.slice(1, 10).split(", ");
    const secondArray = result.split("],")[1].slice(1, -1).split(", ");
    const filteredArray = secondArray?.filter((element: any) => element > 21.3);

    // Log the filtered array
    const dataArray = result.slice(1, -1).split(", ");
    const dataArrayCut = dataArray.slice(0, filteredArray.length);

    const promises = dataArrayCut.map(async (obj: any) => {
      const match = obj.match(/(\d+)/g);
      return match[0];
    });

    const finalList = await Promise.all(promises);

    // Use Set to remove duplicates
    const uniqueFinalList = [...new Set(finalList)];

    return uniqueFinalList;
  } catch (error) {
    // Timeout / network — fail soft so search paint is never blocked.
    return [];
  } finally {
    clearTimeout(timeoutId);
  }
}

export async function extractKeywords(query: any) {
  const options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer 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`,
    },
    body: JSON.stringify({
      model: "gpt-3.5-turbo-instruct",
      // prompt: `Extract at most 3 keywords or phrases from this search term. Keywords must be nouns. Nouns should be ordered in this order - objects first, places second, and people third. Words from the search term that are being used as adjectives in the search term cannot be used as a keyword. For example, if the search term is "diamond ring", "diamond" is being used as an adjective which means it cannot be a keyword. If the search term is only one word, return back just the search term. Each keyword should be only one word and present in the search term. If you have extracted more than 3 keyword, limit your response to the 3 most specific keywords. Order the keywords from the most specific and niche nouns to least specific and niche nouns.  Separate each keyword with a comma. The search term is: ${query}`,
      prompt: `Remove generic terms from the query. The result should have only nouns. If the query is one word return the query itself. Don't give extra word other than from the query. All the terms should be present in the query. The query is: ${query}`,
      temperature: 0.6,
      max_tokens: 100,
      top_p: 1.0,
      frequency_penalty: 1,
      presence_penalty: 1,
    }),
  };

  try {
    const response = await fetch(
      "https://api.openai.com/v1/completions",
      options
    );
    const data = await response.json();
    const word = data.choices[0].text.replace(/.*\n/, "");

    try {
      const data = {
        input: word,
        model: "text-embedding-ada-002",
      };

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization:
            "Bearer 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",
        },
      };

      const response = await axios.post(
        "https://api.openai.com/v1/embeddings",
        data,
        config
      );

      const [{ embedding }] = response.data.data;
      return embedding;
    } catch (error) {
      throw error;
    }
    // Process the response data here if needed
    // return word; // Return the extracted keywords or processed data
  } catch (error) {
    throw error; // Propagate the error for handling outside this function
  }
}
export async function fetchPinterestData(
  username: any,
  user_id: any,
  code: any
) {
  // const url = `https://dev.thesearchbubble.com/fetch/pinterest`

  const url = `${API_BASE}/fetch/pinterest`;
  let res: any = await axios.post(
    url,
    { user: username, user_id: user_id, code: code },
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );

  sendNewIntegrationSlackUpdate(username, user_id, "Pinterest");
  if (res.data === "done") {
    void appendPlatformOnboarded({ userId: user_id, username }, "pinterest");
    return true;
  } else {
    return false;
  }
}
export async function updateShopLink(
  user_id: any,
  username: any,
  post_id: any,
  link: any
) {
  const { error } = await supabase
    .from(`${username}`)
    .update({ shop_link: link })
    .eq("post_id", post_id)
    .eq("user_id", user_id);
  await supabase
    .from("content_new")
    .update({ shop_link: link })
    .eq("post_id", post_id)
    .eq("user_id", user_id);
}

export async function storeTwitterUser(
  user_id: string,
  name: string,
  username: any
): Promise<ResNewsletterStoreContent> {
  const res = {
    error: false,
    message: "",
  };

  try {
    const { username: result, error: extractError } = extractUsername(name, "twitter");
    if (extractError) {
      throw new Error(extractError);
    }

    const validationResponse = await axios.post(
      `${StaticVariables().API_BASE}/verify-twitter`,
      { username: result }
    );

    if (validationResponse?.data?.success !== true) {
      throw new Error("Invalid Twitter username");
    }

    const url = `${API_BASE}/fetch/twitter`;
    const response = axios.post(
      url,
      { userId: user_id, user: username, twitterUser: result },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    await supabase
      .from("user")
      .update({ twitter_user: result, is_twitter_on: true })
      .eq("user_id", user_id)
      .eq("username", username);
   sendNewIntegrationSlackUpdate(username, user_id, "Twitter");
   void appendPlatformOnboarded({ userId: user_id, username }, "twitter");
    return res;
  } catch (error: any) {
    res.error = true;
    // Handle specific error cases
    if (error.response) {
      // Server responded with error status
      if (error.response.status === 400) {
        res.message =
          error.response.data.message ||
          "Invalid Twitter profile. Please check the username and try again.";
      } else if (error.response.status === 500) {
        res.message =
          "Server error. Please try again later or contact support.";
      } else {
        res.message =
          error.response.data.message ||
          "An error occurred while connecting to Twitter.";
      }
    } else if (error.request) {
      // Request made but no response received
      res.message =
        "Unable to connect to the server. Please check your internet connection and try again.";
    } else {
      res.message = error?.message || "An unexpected error occurred. Please try again.";
    }
    return res;
  }
}

// export async function storeFlowdeskId(
//   user_id: any,
//   FormId: any,
//   username: any
// ) {
//   // const formIdMatch = FormId.match(/formId:\s*'([^']+)'/);
//   const regex = /form\/([a-zA-Z0-9]+)/;
//   const match = FormId.match(regex);
//   // return match ? match[1] : null;
//   if (match && match[1]) {
//     const formId = match[1];
//     const { data } = await supabase
//       .from("user")
//       .update({
//         flowdesk_user: formId,
//         show_flowdesk: true,
//         is_flowdesk_on: true,
//       })
//       .eq("user_id", user_id);
//   } else {
//   }
// }

export async function storeFlowdeskId(
  user_id: any,
  formId: any,
  username: any
) {
  // Match common Flodesk form ID formats
  // const regex = /(?:https?:\/\/)?(?:form|app)\.flodesk\.com\/(?:forms?\/)?([a-zA-Z0-9]+)(?:\/.*)?/;
  // const match = FormId.match(regex);

  // const formId = match ? match[1] : null;
  if (formId) {
    const { data, error } = await supabase
      .from("user")
      .update({
        flowdesk_user: formId,
        show_flowdesk: true,
        is_flowdesk_on: true,
      })
      .eq("user_id", user_id);

    if (error) {
      console.error("Supabase update error:", error);
    } else {
      void appendPlatformOnboarded({ userId: user_id, username }, "flowdesk");
    }
  } else {
    console.warn("No valid Flodesk form ID found in input:", formId);
  }
}

// export async function storeFlowdeskPopupId(
//   user_id: any,
//   FormId: any,
//   username: any
// ) {
//   // const formIdMatch = FormId.match(/formId:\s*'([^']+)'/);
//   const regex = /form\/([a-zA-Z0-9]+)/;
//   const match = FormId.match(regex);
//   // return match ? match[1] : null;
//   if (match && match[1]) {
//     const formId = match[1];
//     const { data } = await supabase
//       .from("user")
//       .update({
//         flowdeskpopup_user: formId,
//         show_flowdeskpopup: true,
//         is_flowdeskpopup_on: true,
//       })
//       .eq("user_id", user_id);
//   } else {
//   }
// }

export async function storeFlowdeskPopupId(
  user_id: any,
  formId: any,
  username: any
) {
  // Match form ID in both common Flodesk URL patterns
  // const regex = /(?:https?:\/\/)?(?:form|app)\.flodesk\.com\/(?:forms?\/)?([a-zA-Z0-9]+)(?:\/.*)?/;
  // const match = FormId.match(regex);

  // const formId = match ? match[1] : null;

  if (formId) {
    const { data, error } = await supabase
      .from("user")
      .update({
        flowdeskpopup_user: formId,
        show_flowdeskpopup: true,
        is_flowdeskpopup_on: true,
      })
      .eq("user_id", user_id);

    if (error) {
      console.error("Supabase update error:", error);
    } else {
      void appendPlatformOnboarded({ userId: user_id, username }, "flowdeskpopup");
    }
  } else {
    console.warn("No valid Flodesk form ID found in input:", formId);
  }
}

export async function storeFilloutId(user_id: any, FormId: any, username: any) {
  // Handle different Fillout URL formats
  // Examples:
  // - https://forms.fillout.com/t/9Mfibx8yRmus
  // - https://fillout.com/forms/abc123
  // - https://app.fillout.com/form/xyz789
  // - Just the form ID: 9Mfibx8yRmus

  let id = null;

  // Try different URL patterns
  const patterns = [
    /\/t\/([a-zA-Z0-9]+)/, // /t/ID format
    /\/forms?\/([a-zA-Z0-9]+)/, // /forms/ID or /form/ID format
    /\/form\/([a-zA-Z0-9]+)/, // /form/ID format
    /^([a-zA-Z0-9]+)$/, // Just the ID itself
  ];

  for (const pattern of patterns) {
    const match = FormId.match(pattern);
    if (match && match[1]) {
      id = match[1];
      break;
    }
  }

  if (id) {
    const { data, error } = await supabase
      .from("user")
      .update({ fillout_user: id, show_fillout: true, is_fillout_on: true })
      .eq("user_id", user_id);

    if (error) {
      throw new Error(`Failed to save Fillout ID: ${error.message}`);
    }
    void appendPlatformOnboarded({ userId: user_id, username }, "fillout");
  } else {
    throw new Error(
      "Invalid Fillout URL format. Please provide a valid Fillout form URL (e.g., https://forms.fillout.com/t/your-form-id or just the form ID)."
    );
  }
}

function mergePreservedSearchText(nextText: string, previousText: string): string {
  const nextTokens = new Set(
    nextText
      .toLowerCase()
      .split(/\s+/)
      .filter(Boolean)
  );
  const extras: string[] = [];
  const seenExtras = new Set<string>();
  for (const token of previousText.split(/\s+/)) {
    const key = token.toLowerCase();
    if (!token || nextTokens.has(key) || seenExtras.has(key)) continue;
    seenExtras.add(key);
    extras.push(token);
  }
  if (extras.length === 0) return nextText;
  return `${nextText} ${extras.join(" ")}`.replace(/\s+/g, " ").trim();
}

export async function UpdateCombinedText(
  username: any,
  user_id: any,
  post_id: any,
  options?: { preserveExistingSearchText?: boolean }
) {
  const columnsToCombine = [
    "caption",
    "tagg",
    "ocr",
    "content_category",
    "product_name",
    "content_title",
    "shop_title",
    "metadata",
  ];
  const wordsToRemove = ["amazon", "shopmy", "ltk","Amazon","ShopMy","LTK"];
  const selectColumns = options?.preserveExistingSearchText
    ? [...columnsToCombine, "combined_text", "text"]
    : columnsToCombine;
  // Step 1: Fetch the data for the specific post and user
  const { data, error: fetchError } = await supabase
    .from(username)
    .select(selectColumns.join(",")) // Select only relevant columns
    .eq("post_id", post_id)
    .eq("user_id", user_id);

  if (fetchError || !data || data.length === 0) {
    console.error("Error fetching data:", fetchError);
    return { success: false, message: "Failed to fetch data." };
  }

  let rawCombinedText = Array.from(
    new Set(
      columnsToCombine
        .map((col) => String(data[0]?.[col] ?? "").trim())
        .filter(Boolean)
    )
  ).join(" ");

  // Product OCR is written into combined_text/text by /ocr-and-embed-single,
  // not always into the `ocr` column. Rebuilding from name fields alone
  // would drop those keywords and pull the product out of query carousels.
  if (options?.preserveExistingSearchText) {
    const previousCombined = (data[0]?.combined_text || data[0]?.text || "").trim();
    rawCombinedText = mergePreservedSearchText(rawCombinedText, previousCombined);
  }


  const cleanTextForEmbedding = rawCombinedText
    .toLowerCase()
    .replace(
      new RegExp(`\\b(${wordsToRemove.join("|")})\\b`, "gi"),
      ""
    )
    .replace(/\s+/g, " ") // remove extra spaces
    .trim(); // Concatenate with spaces

  const embeddingText = cleanTextForEmbedding || rawCombinedText.trim();

  // Step 3: Update the table with the new combined_text
  const { error: updateError } = await supabase
    .from(username)
    .update({ combined_text: rawCombinedText, text: rawCombinedText })
    .eq("post_id", post_id)
    .eq("user_id", user_id);
  await supabase
    .from("content_new")
    .update({ combined_text: rawCombinedText})
    .eq("post_id", post_id)
    .eq("user_id", user_id);
  const embedUrl = `${StaticVariables().API_BASE}/post-embedding`;
  if (embeddingText) {
    axios
      .post(embedUrl, {
        id: user_id,
        user: username,
        post_id: post_id,
        combined_text: embeddingText,
      })
      .catch((error) => {
        console.error("Error posting embedding:", error);
      });
  }
  if (updateError) {
    console.error("Error updating combined_text:", updateError);
    return { success: false, message: "Failed to update combined_text." };
  }
  syncRemovedPostIdsAfterCombinedTextUpdate(user_id, username, post_id)

  return { success: true, message: "combined_text updated successfully." };
}

async function syncRemovedPostIdsAfterCombinedTextUpdate(
  user_id: string,
  username: string,
  post_id: string
) {

  // Step 1: Fetch combined_text directly from username table
  const { data: postData, error: postError } = await supabase
    .from(username)
    .select("combined_text, text")
    .eq("post_id", post_id)
    .eq("user_id", user_id)
    .single();

  if (postError || !postData) {
    console.error("[syncRemovedPostIds] Failed to fetch post from username table", { postError, post_id });
    return;
  }

  const combinedText = (postData.combined_text || postData.text || "").toLowerCase().trim();

  const { data: components, error: componentsError } = await supabase
    .from("stayuptodate_components")
    .select("id, query, removed_postids, name")
    .eq("user_id", user_id)
    .eq("type", "query-content")
    .neq("status", "deleted");

  if (componentsError || !components?.length) {
    return;
  }

  if (!combinedText) {

    for (const component of components) {
      const removedIds: string[] = (component.removed_postids || "")
        .split(",")
        .map((s: string) => s.trim())
        .filter(Boolean);

      if (!removedIds.includes(String(post_id))) {
        continue;
      }

      const updatedRemovedIds = removedIds
        .filter((id) => id !== String(post_id))
        .join(",");

      const { error: updateError } = await supabase
        .from("stayuptodate_components")
        .update({ removed_postids: updatedRemovedIds })
        .eq("id", component.id)
        .eq("user_id", user_id);

      if (updateError) {
        console.error(`[syncRemovedPostIds] Failed to update component "${component.name}"`, updateError);
      } else {
      }
    }
    return;
  }

  for (const component of components) {
    const removedIds: string[] = (component.removed_postids || "")
      .split(",")
      .map((s: string) => s.trim())
      .filter(Boolean);

    if (!removedIds.includes(String(post_id))) {
      continue;
    }

    const queryKeywords = transformQueryLikeFeed(component.query || "");

    if (!queryKeywords.length) {
      continue;
    }

    const keywordMatchResults = queryKeywords.map((keyword) => ({
      keyword,
      matches: combinedText.includes(keyword),
    }));

    const isStillRelevant = keywordMatchResults.every((r) => r.matches);

    if (!isStillRelevant) {
      const updatedRemovedIds = removedIds
        .filter((id) => id !== String(post_id))
        .join(",");

      const valueToStore = updatedRemovedIds || "";

      const { error: updateError } = await supabase
        .from("stayuptodate_components")
        .update({ removed_postids: valueToStore })
        .eq("id", component.id)
        .eq("user_id", user_id);

      if (updateError) {
        console.error(`[syncRemovedPostIds] Failed to update component "${component.name}"`, updateError);
      } 
    } else {
      return;
    }
  }

}

function transformQueryLikeFeed(queryTerm: string): string[] {
  if (!queryTerm) return [];

  let normalized = queryTerm.toLowerCase().replace(/\s+/g, " ").trim();
  const connectingWords = StaticVariables().connectingWords;
  let words = normalized.split(" ");

  // Strip trailing 's' for single word queries
  if (
    words.length === 1 &&
    !StaticVariables().SEARCH_EXCEPTIONS.includes(normalized)
  ) {
    const suffixRegex = /(s)$/i;
    if (suffixRegex.test(words[0])) {
      words = [words[0].replace(suffixRegex, "")];
    }
  }

  // Strip "shop"/"buy" keywords
  words = words.filter((word) => word !== "shop" && word !== "buy");

  // Strip connecting words
  words = words.filter(
    (word) => !connectingWords.includes(word.toLowerCase())
  );

  return words.filter(Boolean);
}

export async function sendNewIntegrationSlackUpdate(
  username: any,
  user_id: any,
  platform: any
) {
  const channel = "#newintegrations";
  const url = `${StaticVariables().API_BASE}/slack/update`;
  const headers = { "Content-Type": "application/json" };

  const { data } = await supabase.from("user").select("*").eq("user_id", user_id);
  const details = data?.[0];
  const email = details?.email || "";
  const creatoropsPattern = /^creatorops\+.*@gmail\.com$/i;
  
  if (creatoropsPattern.test(email)) {
    return; // Skip Slack notification
  }
  const platformMessages: Record<string, string> = {
    YouTube: `YouTube Integration
    Username: ${username},

    YouTube Channel ID: ${details?.youtube_channel_id}
    User ID: ${user_id}`,

    Twitter: `Twitter Integration
    Username: ${username},

    Twitter Handle: ${details?.twitter_user}
    User ID: ${user_id}`,

    Newsletter: `Newsletter Integration
    Username: ${username},

    Email: ${details?.newsletter_email}
    Website Link: ${details?.newsletter_website_link || "Not provided"}
    User ID: ${user_id}`,

    LinkedIn: `LinkedIn Integration
    Username: ${username},

    LinkedIn Username: ${details?.linkedin_user}
    User ID: ${user_id}`,

    Podcast: `Podcast Integration
    Username: ${username},

    Podcast Show Name: ${details?.podcast_showname},
    Podcast Show URL: ${details?.podcast_link},
    Podcast Show ID: ${details?.podcast_id}
    User ID: ${user_id}`,

    TikTok: `TikTok Integration
    Username: ${username},

    TikTok Handle: ${details?.tiktok_user}
    User ID: ${user_id}`,

    Instagram: `Instagram Integration
    Username: ${username},

    Instagram Handle: ${details?.instagram_user}
    User ID: ${user_id}`,

    Pinterest: `Pinterest Integration
    Username: ${username},

    User ID: ${user_id}`,

    ShopMy: `ShopMy Integration
    Username: ${username},

    ShopMy Link: ${details?.social_affiliate_shopmy || details?.social_shopmy}
    User ID: ${user_id}`,

    Amazon: `Amazon Integration
    Username: ${username},

    Amazon Link: ${details?.social_affiliate_amazon || details?.social_amazon}
    User ID: ${user_id}`,

    LTK: `LTK Integration 
    Username: ${username},

    LTK Link: ${details?.social_affiliate_ltk || details?.social_ltk}
    User ID: ${user_id}`,
  };

  if (!platformMessages[platform]) return;

  try {
    const resServer = await axios.post(
      url,
      {
        userId: user_id,
        user: username,
        channel,
        msg: platformMessages[platform],
      },
      { headers }
    );

    const { success, message } = resServer.data;
    // Optionally handle success/message here if needed
  } catch (error) {
    // Optionally log or handle error here
  }
}
